import { useState } from 'react';

import GerenciamentoIndicesProjecao from '../../components/GerenciamentoIndicesProjecao/GerenciamentoIndicesProjecao';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function IndicesProjecaoGerenciamento() {

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });


    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        <GerenciamentoIndicesProjecao  setNotifier = {(isSuccess, message) => setNotify({
                isActive: true,
                isSuccessful: isSuccess,
                message: message
            })} />
    </>
}